import React, { useEffect, useState } from 'react';
import teamService from '../services/teamService';
import TeamBadge from './TeamBadge';

const TeamsList = () => {
	const [teams, setTeams] = useState([]);
	const [filteredTeams, setFilteredTeams] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [filter, setFilter] = useState(''); // Filtrování sport type

	useEffect(() => {
		const fetchTeams = async () => {
			try {
				const data = await teamService.getAllTeams();
				// Set the teams sorted alphabetically
				const sortedTeams = data.sort((a, b) => a.name.localeCompare(b.name));
				setTeams(sortedTeams);
				setFilteredTeams(sortedTeams); // Initially show all teams
				setLoading(false);
			} catch (err) {
				console.error('Error fetching teams:', err);
				setError(`Failed to fetch teams: ${err.message}`);
				setLoading(false);
			}
		};

		fetchTeams();
	}, []);

	// Handle filter change
	const handleFilterChange = (e) => {
		const sportType = e.target.value;
		setFilter(sportType);

		if (sportType === '') {
			setFilteredTeams(teams); // No filter applied
		} else {
			const filtered = teams.filter((team) => team.sportType === sportType);
			setFilteredTeams(filtered);
		}
	};

	if (loading) return <div>Loading...</div>;
	if (error) return <div style={{ color: 'red' }}>{error}</div>;

	if (filteredTeams.length === 0) {
		return <div>No teams match the selected filter.</div>;
	}

	return (
		<div>
			<h1>All Teams</h1>

			{/* Sport Type Filter */}
			<div>
				<label>Filter by Sport Type: </label>
				<select value={filter} onChange={handleFilterChange}>
					<option value="">All</option>
					<option value="FOOTBALL">Football</option>
					<option value="HOCKEY">Hockey</option>
				</select>
			</div>

			<table>
				<thead>
					<tr>
						<th>ID</th>
						<th>Name</th>
						<th>Sport Type</th>
						<th>Badge</th>
						<th>SportDB API ID</th>
					</tr>
				</thead>
				<tbody>
					{filteredTeams.map((team) => (
						<tr key={team.id}>
							<td>{team.id}</td>
							<td>{team.name}</td>
							<td>{team.sportType}</td>
							<td><TeamBadge teamId={team.id} teamName={team.name} /></td>
							<td>{team.sportDbApiId}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default TeamsList;
